// src/Context/RoleContext.tsx or src/syllabus/RoleContext.tsx
import React, { createContext, useContext, useState, ReactNode } from 'react';

export type UserRole = 'teacher' | 'coordinator';

interface RoleContextType {
  role: UserRole;
  setRole: (role: UserRole) => void;
  isTeacher: boolean;
  isCoordinator: boolean;
}

const RoleContext = createContext<RoleContextType | undefined>(undefined);

export function RoleProvider({ children }: { children: ReactNode }) {
  const [role, setRole] = useState<UserRole>('teacher');

  return (
    <RoleContext.Provider
      value={{
        role,
        setRole,
        isTeacher: role === 'teacher',
        isCoordinator: role === 'coordinator',
      }}
    >
      {children}
    </RoleContext.Provider>
  );
}

export function useRole() {
  const context = useContext(RoleContext);
  if (context === undefined) {
    throw new Error('useRole must be used within a RoleProvider');
  }
  return context;
}